/* eslint-disable camelcase */

import * as t from 'io-ts';

import {isHtml} from '../../../libs/shared/helpers/src/utilities/stringHelpers';
import {htmlToText} from '../../../srcCommon/services/converters/htmlToTextConverter';
import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RSearchHelpCenterDirty = t.readonly(
  t.type({
    title: t.string,
    text: t.string,
    url: t.string,
  }),
);

export const RSearchHelpCenterArticles = t.readonlyArray(RSearchHelpCenterDirty);

export const RSearchHelpCenterResult = t.readonly(
  t.type({
    count: t.number,
    url: t.string,
    articles: RSearchHelpCenterArticles,
  }),
);

/*
 * Type.
 */

export interface SearchHelpCenterModel extends t.TypeOf<typeof RSearchHelpCenterDirty> {}

export interface SearchHelpCenterResultModel extends t.TypeOf<typeof RSearchHelpCenterResult> {}

/*
 * IO methods.
 */

export function parseSearchHelpCenterArticle(src: any): SearchHelpCenterModel {
  return {
    title: src.title,
    text: isHtml(src.text) ? htmlToText(src.text) : src.text,
    url: src.url,
  };
}

export function parseSearchHelpCenterArticles(src: any): SearchHelpCenterResultModel {
  const {articles, count, web_url} = src;
  return {
    count,
    url: web_url,
    articles: articles.map(parseSearchHelpCenterArticle),
  };
}

/*
 * API type.
 */

export const ApiSearchHelpCenterArticles = makeApiType(
  'searchHelpCenterArticles',
  RSearchHelpCenterResult,
  parseSearchHelpCenterArticles,
);
